/* hm-ef-sticky: widoczny, gdy galeria i cały blok zakupu są nad ekranem, a finał jeszcze daleko; podąża za planem (hm:plan). */
(function () {
  function init(st) {
    if (!st || st.dataset.hmInit) return;
    st.dataset.hmInit = '1';
    var buy = document.querySelector(st.dataset.watch || '#buy'), gal = document.querySelector(st.dataset.gallery || ''), fin = document.querySelector(st.dataset.end || '#final'), tick = false;
    function check() {
      tick = false;
      var vh = window.innerHeight, b = buy ? buy.getBoundingClientRect() : null, g = gal ? gal.getBoundingClientRect() : null;
      var past = !!g && g.bottom < 0 && !(b && b.top < vh && b.bottom > 0) && (!fin || fin.getBoundingClientRect().top > vh * 0.6);
      st.classList.toggle('show', past);
      st.inert = !past;
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
    function plan(d) {
      d = d || {};
      if (d.title) st.querySelector('[data-st-title]').textContent = d.title;
      if (d.sub) st.querySelector('[data-st-sub]').textContent = d.sub;
      if (d.button) st.querySelector('[data-st-btn]').textContent = d.button;
    }
    if (window.HM && HM.plan) plan(HM.plan);
    document.addEventListener('hm:plan', function (e) { plan(e.detail); });
  }
  function all() { document.querySelectorAll('[data-hm-sticky]').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', all);
})();
